import React from 'react';

const Footer = () => {
    return (
        <>
            <footer id="footer">
                <div className="container">

                    <p>
                        &copy;
                        <a
                            href="https://abhaychaudhary.com.np"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Abhay Chaudhary
                        </a>
                    </p>
                </div>
            </footer>
        </>
    );
};

export default Footer;